export const CrownLogo = ({ className = "", showText = true }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
    <img
      src="/carlocs-logo-192.png"
      alt="Carlocs crown"
      className="h-10 w-10 rounded-full object-contain"
    />
    {showText && (
      <div className="leading-tight">
        <span className="block font-heading text-lg font-600 tracking-wide text-cream">Carlocs</span>
        <span className="block text-[9px] uppercase tracking-[0.3em] text-gold/80">Scalp Analyzer</span>
      </div>
    )}
  </div>
);
